import { Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React from "react";

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
    >
      <GridToolbarQuickFilter />
      <div className="flex">
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </div>
    </GridToolbarContainer>
  );
}

export const SmartClassOpsTable = ({ data }) => {
  const [pageSize, setPageSize] = React.useState(25);
  const columns = [
    {
      field: "center_id",
      headerName: "Center ID",
    },
    {
      field: "center_name",
      headerName: "Center Name",
      width: 200,
    },
    {
      field: "activation_status",
      headerName: "Activation Status",
      width: 150,
    },
    {
      field: "license_start_date",
      headerName: "License Start Date",
      width: 150,
    },
    {
      field: "license_end_date",
      headerName: "License End Date",
      width: 150,
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      width: 150,
    },
    {
      field: "school_name",
      headerName: "School Name",
      width: 250,
    },
    {
      field: "district",
      headerName: "District",
    },
  ];

  return (
    <div className="smart-class-ops-table-container">
      <Typography variant="h6" component="div" className="mt-5">
        Smart Class Operation Status
      </Typography>
      {data && (
        <DataGrid
          columns={columns}
          rows={data}
          pageSize={pageSize}
          rowsPerPageOptions={[25, 50, 100]}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          pagination
          rowHeight={50}
          sx={{ marginTop: "2.5em", width: "100%" }}
          autoHeight={true}
          getRowId={(row) => row.center_id}
          components={{
            Toolbar: CustomToolbar,
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      )}
    </div>
  );
};
